import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import PropTypes from "prop-types";
import React, { Component } from "react";
import { getRehydratableName, getClassNameFactory } from "../../../../utilities";
import Form from "../../";

var PrivacyControl = /*#__PURE__*/function (_Component) {
  _inherits(PrivacyControl, _Component);

  var _super = _createSuper(PrivacyControl);

  function PrivacyControl(props) {
    var _this;

    _classCallCheck(this, PrivacyControl);

    _this = _super.call(this, props);
    _this.state = {
      hasGivenExplicitConsent: "undefined",
      showExplicitConsent: false
    };
    _this.myRef = /*#__PURE__*/React.createRef();
    _this.getClassName = getClassNameFactory(PrivacyControl.displayName);
    _this.getCountryDropdown = _this.getCountryDropdown.bind(_assertThisInitialized(_this));
    _this.handleCountryChange = _this.handleCountryChange.bind(_assertThisInitialized(_this));
    _this.handleExplicitConsentChange = _this.handleExplicitConsentChange.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(PrivacyControl, [{
    key: "getCountryDropdown",
    value: function getCountryDropdown() {
      var name = this.props.dependsOn;
      var countryDropdown = this.myRef.current.closest("form").querySelector("[name=".concat(name, "]"));

      if (countryDropdown === null) {
        throw new Error("Could not find the country dropdown specified in dependsOn prop");
      }

      return countryDropdown;
    }
  }, {
    key: "handleCountryChange",
    value: function handleCountryChange(event) {
      var selectedCountry = event.target.value;

      if (this.props.compliantCountries.includes(selectedCountry)) {
        this.setState({
          hasGivenExplicitConsent: false,
          showExplicitConsent: true
        });
      } else {
        this.setState({
          hasGivenExplicitConsent: "undefined",
          showExplicitConsent: false
        });
      }
    }
  }, {
    key: "handleExplicitConsentChange",
    value: function handleExplicitConsentChange(event) {
      var target = event.target;
      var value = target.checked;
      this.setState({
        hasGivenExplicitConsent: value
      });
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var countryDropdown = this.getCountryDropdown();
      countryDropdown.addEventListener("change", this.handleCountryChange);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var countryDropdown = this.getCountryDropdown();
      countryDropdown.removeEventListener("change", this.handleCountryChange);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          compliantCountries = _this$props.compliantCountries,
          consentName = _this$props.consentName,
          consentText = _this$props.consentText,
          dependsOn = _this$props.dependsOn,
          explicitConsentId = _this$props.explicitConsentId,
          explicitConsentText = _this$props.explicitConsentText;
      var _this$state = this.state,
          hasGivenExplicitConsent = _this$state.hasGivenExplicitConsent,
          showExplicitConsent = _this$state.showExplicitConsent;
      return /*#__PURE__*/React.createElement("div", {
        className: this.getClassName(),
        "data-compliant-countries": JSON.stringify(compliantCountries),
        "data-consent-name": consentName,
        "data-depends-on": dependsOn,
        "data-explicit-consent-id": explicitConsentId,
        "data-explicit-consent-text": explicitConsentText,
        "data-rehydratable": getRehydratableName(PrivacyControl.displayName),
        ref: this.myRef
      }, showExplicitConsent ? /*#__PURE__*/React.createElement(Form.CheckboxControl, {
        checked: hasGivenExplicitConsent,
        id: explicitConsentId,
        labelText: explicitConsentText,
        onChange: this.handleExplicitConsentChange
      }) : /*#__PURE__*/React.createElement("div", {
        className: this.getClassName({
          descendantName: "consent"
        })
      }, consentText), /*#__PURE__*/React.createElement("input", {
        name: consentName,
        type: "hidden",
        value: hasGivenExplicitConsent
      }));
    }
  }]);

  return PrivacyControl;
}(Component);

_defineProperty(PrivacyControl, "displayName", "Form.PrivacyControl");

_defineProperty(PrivacyControl, "defaultProps", {
  consentName: "consent",
  explicitConsentId: "explicitConsentCheckbox"
});

_defineProperty(PrivacyControl, "propTypes", {
  /**
   * List of all countries that require strict privacy control
   */
  compliantCountries: PropTypes.array.isRequired,

  /**
   * Name attribute of the hidden input that passes the consent value
   */
  consentName: PropTypes.string.isRequired,

  /**
   * Default consent message
   */
  consentText: PropTypes.node.isRequired,

  /**
   * Name attribute of the country dropdown Privacy Control depends on
   */
  dependsOn: PropTypes.string.isRequired,

  /**
   * Id attribute for the explicit consent opt-in checkbox
   */
  explicitConsentId: PropTypes.string,

  /**
   * Explicitly opt-in consent for GDPR-affected countries
   */
  explicitConsentText: PropTypes.string.isRequired
});

export default PrivacyControl;